import { useState } from 'react'
import { CloseIcon } from './icons/CloseIcon'
import { SaveIcon } from './icons/SaveIcon'
import { Spinner } from './Spinner'
import { UnsavedChangesDialog } from './UnsavedChangesDialog'

interface PageSaveDiscardActionsProps {
  dirty: boolean
  saving: boolean
  onSave: () => void
  onDiscard: () => void
  saveLabel: string
  discardLabel: string
}

/**
 * Page-level Save/Discard header buttons (checkmark + X, per prototype order).
 * Discard always confirms via the shared UnsavedChangesDialog — this is the
 * one place that wiring lives, so a page can't ship a Discard button that
 * skips the confirm.
 */
export function PageSaveDiscardActions({
  dirty,
  saving,
  onSave,
  onDiscard,
  saveLabel,
  discardLabel,
}: PageSaveDiscardActionsProps) {
  const [discardDialogOpen, setDiscardDialogOpen] = useState(false)
  const disabled = !dirty || saving

  return (
    <>
      <button
        type="button"
        onClick={onSave}
        disabled={disabled}
        title={saveLabel}
        aria-label={saveLabel}
        className="pg-act save"
        style={{ opacity: disabled ? 0.3 : 1, pointerEvents: disabled ? 'none' : 'auto', color: 'var(--accent)' }}
      >
        {saving ? <Spinner size={16} /> : <SaveIcon />}
      </button>

      <button
        type="button"
        onClick={() => setDiscardDialogOpen(true)}
        disabled={disabled}
        title={discardLabel}
        aria-label={discardLabel}
        className="pg-act discard"
        style={{ opacity: disabled ? 0.3 : 1, pointerEvents: disabled ? 'none' : 'auto', color: 'var(--danger)' }}
      >
        <CloseIcon size={18} />
      </button>

      {discardDialogOpen && (
        <UnsavedChangesDialog
          onConfirm={() => {
            onDiscard()
            setDiscardDialogOpen(false)
          }}
          onCancel={() => setDiscardDialogOpen(false)}
        />
      )}
    </>
  )
}
